import { Box, } from "@mui/material"
import { useEffect, useState } from "react"
import BuyWithAutoComplete from "../manual-buy/BuyWithAutoComplete"
import CRUDDataTable from "../../util/CRUDDataTable"



export const PreMarketBuy = ({ user }) => {
    const [alert, setAlert] = useState({
        message: '',
        open: false,
        severity: 'error'
    })

    const [preMarketBuyData, setPreMarketBuyData] = useState([])

    const [selectedSymbol, setSelectedSymbol] = useState(null)

    const columnsData = [
        { field: 'id', headerName: 'ID', width: 90, editable: false },
        {
            field: 'symbol', headerName: 'Symbol', width: 300, editable: true,
            renderEditCell: (params) => {
                const symbol = params?.row?.symbol
                if (params?.row?.isNew) {
                    return <Box sx={{ width: '100%' }}>
                        <BuyWithAutoComplete user={user} setSelectedSymbol={setSelectedSymbol} />
                    </Box>
                }
                // In Edit mode, do not show symbol Autocomplete
                return <Box sx={{ width: '100%' }}>{symbol}</Box>
            },
        },
        { field: 'upperCircuitPrice', headerName: 'Upper Circuit Price', width: 150, editable: true },
        { field: 'priority', headerName: 'Priority', width: 150, editable: true },
        { field: 'createdOn', headerName: 'Created On', width: 150, editable: false },
        { field: 'tradedOn', headerName: 'Traded On', width: 150, editable: false },
    ]

    useEffect(() => {
        getPreMarketBuyData()
    }, [user])

    const getPreMarketBuyData = async () => {
        fetch('/algo-trading/api/admin/pre-market-buy',
            {
                headers: {
                    'Authorization': user?.credential,
                    'Content-Type': 'application/json'
                },
            }
        ).then(r => r.json())
            .then(setPreMarketBuyData)
    }

    const onAdd = async (data) => {
        data.symbol = selectedSymbol?.symbol
        data.token = selectedSymbol?.token
        return fetch('/algo-trading/api/admin/pre-market-buy', {
            method: 'POST',
            headers: {
                'Authorization': user?.credential,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
    }

    const onUpdate = async (data) => {
        return fetch(`/algo-trading/api/admin/pre-market-buy/${data.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': user?.credential,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
    }

    const onDelete = async (id) => {
        return fetch(`/algo-trading/api/admin/pre-market-buy/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': user?.credential,
                'Content-Type': 'application/json'
            }
        })
    }

    return (
        <>
            <CRUDDataTable
                title={"Pre Market Buy"}
                columnsData={columnsData}
                initialRows={preMarketBuyData}
                onAdd={onAdd}
                onUpdate={onUpdate}
                onDelete={onDelete}
                refreshData={getPreMarketBuyData}
            />
        </>
    )
}